import { useTheme as useThemeReact } from "@bpipartners/webui";
import { createTheme } from "@bpipartners/webui";
import { dimensions } from "./dimensions";

import { appColors, appPalette, vpsColours } from "./cbex.colors";
import { colors } from "./webshop.colors";

// ------------------------------------------------------------------------------

export const getTheme = (appName: string) => {
  let localPalette;
  let localAppColours;

  switch (appName) {
    case "cbex":
      localAppColours = appColors;
      localPalette = appPalette;
      break;
    case "vps":
      localAppColours = vpsColours;
      localPalette = appPalette;
      break;
    case "webshop":
      localAppColours = colors.appColors;
      localPalette = colors.appPalette;
      break;
    default:
      localAppColours = appColors;
      localPalette = appPalette;
      break;
  }

  const materialTheme = createTheme({
    spacing: 4,
    components: {
      MuiSelect: {
        defaultProps: { variant: "filled", size: "small" },
        styleOverrides: {
          root: {
            "& .MuiMenuItem-root.Mui-selected": {
              backgroundColor: localPalette.secondary[80],
            },
          },
        },
      },
      MuiFormControl: { defaultProps: { variant: "filled", size: "small" } },
      MuiTextField: {
        defaultProps: { variant: "filled", size: "small" },
      },
      MuiDatePicker: {
        defaultProps: {
          slotProps: { textField: { variant: "filled", size: "small" } },
        },
      },
      MuiDateRangePicker: {
        defaultProps: {
          slotProps: { textField: { variant: "filled", size: "small" } },
        },
      },
      MuiDateTimePicker: {
        defaultProps: {
          slotProps: { textField: { variant: "filled", size: "small" } },
        },
      },
      MuiPaper: {
        defaultProps: {
          variant: "outlined",
        },
        styleOverrides: {
          root: {
            // borderRadius: 12,
            padding: 0,
            paddingTop: 8,
            paddingBottom: 8,
            backgroundColor: localAppColours.surfaceContainerLowest,
          },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            borderRadius: 0,
          },
        },
      },
      MuiButton: {
        defaultProps: {
          size: "medium",
        },
        styleOverrides: {
          root: {
            borderRadius: 24,
            height: 36,
            textTransform: "none",
            // background: colors.appColors.tertiary,
          },
        },
      },
    },
    palette: {
      DataGrid: {
        headerBg: localPalette.secondary[80],
        pinnedBg: localPalette.secondary[80],
      },

      // type: "light",
      background: {
        default: localPalette.neutral[100],
        paper: localAppColours.surfaceContainerLowest,
      },
      primary: {
        light: localPalette.primary[80],
        main: localPalette.primary[60],
        dark: localPalette.primary[30],
        contrastText: localAppColours.onPrimary,
      },
      secondary: {
        light: localPalette.secondary[60],
        main: localAppColours.secondary,
        dark: localAppColours.secondary[30],
        contrastText: localAppColours.onSecondary,
      },
    },
  });
  return {
    ...materialTheme,
    // Override material default: show header above drawer (sidebar)
    zIndex: {
      ...materialTheme.zIndex,
      appBar: materialTheme.zIndex.drawer,
      drawer: materialTheme.zIndex.appBar,
    },
    appColors: localAppColours,
    appPalette: localPalette,
    dimensions,
  };
};

export type Theme = ReturnType<typeof getTheme>;

export const useTheme = () => useThemeReact() as Theme;
